import React, { Fragment, useState } from "react";
import ModalVideo from "react-modal-video";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import bannerEmail from "../../images/banners/banner_email.png";

const MicrosoftExchangePage = (props) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> Microsoft Exchange
                      </span>
                      <h2 className="title">
                        Email empresarial profissional com segurança máxima e
                        produtividade garantida
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerEmail} alt="Email Banner" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  Microsoft Exchange Somar: Email Empresarial de Classe Mundial
                </h2>
                <p className="sd-content">
                  O Microsoft Exchange da Somar Cloud oferece a mais robusta
                  solução de email e colaboração empresarial do mercado, com
                  tecnologia Microsoft genuína hospedada em nossa infraestrutura
                  nacional de alta segurança. Com caixas postais de até 100GB,
                  proteção avançada contra spam e malware, e integração completa
                  com Office 365, sua empresa terá comunicação profissional de
                  nível corporativo.
                </p>
                <br />
                <p className="sd-content">
                  Nossa implementação Exchange inclui recursos avançados como
                  calendários compartilhados, salas de reunião virtuais, listas
                  de distribuição inteligentes, e políticas de retenção
                  personalizáveis. Com tecnologia anti-phishing baseada em IA,
                  DLP (Data Loss Prevention) e criptografia end-to-end,
                  garantimos que suas comunicações empresariais estejam sempre
                  protegidas contra ameaças digitais.
                </p>
                <br />
                <p className="sd-content">
                  <strong>Diferenciais exclusivos Somar:</strong> Hospedagem em
                  datacenter nacional (conformidade LGPD), backup de emails em
                  tempo real, migração transparente de qualquer plataforma,
                  suporte técnico especializado 24/7 em português, e integração
                  nativa com Active Directory. Elimine problemas de email e
                  potencialize a colaboração da sua equipe.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Processo de Migração Exchange</h2>
                <p className="sd-content">
                  Nossa metodologia de migração Exchange garante transferência
                  completa de emails, contatos e calendários sem perda de dados
                  ou interrupção de serviços.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Análise de Ambiente</h3>
                  <p className="xb-item--contact">
                    Avaliação completa da infraestrutura de email atual.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Configuração Personalizada</h3>
                  <p className="xb-item--contact">
                    Setup de Exchange otimizado para suas necessidades
                    específicas.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Migração Controlada</h3>
                  <p className="xb-item--contact">
                    Transferência gradual de dados com validação contínua.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Treinamento e Suporte</h3>
                  <p className="xb-item--contact">
                    Capacitação de usuários e suporte técnico contínuo.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">Vantagens do Exchange Somar</h2>
                  <p className="sd-content">
                    Transforme a comunicação da sua empresa com email
                    empresarial de classe mundial, oferecendo produtividade
                    máxima e segurança total.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Caixas postais de até 100GB por usuário
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Proteção avançada anti-spam e anti-malware
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Calendários compartilhados e salas virtuais
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Integração completa com Office 365
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Backup automático em tempo real
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Compliance total com LGPD
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Acesso via webmail, Outlook e mobile
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Suporte técnico especializado 24/7
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};

export default MicrosoftExchangePage;
